import React from 'react';

const CheckboxIcon = () => (
  <svg width="55" height="46" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 46">
    <path
      d="M21.5 32.343L50.996 2.847l5.657 5.658L21.5 43.635 2.125 24.283l5.657-5.657L21.5 32.343z"
      fill="#000"
      stroke="#FFF"
      strokeWidth="3"
      fillRule="evenodd"
    />
  </svg>
);

export default CheckboxIcon;
